// extracted by mini-css-extract-plugin
export default {"header":"greeting_header__9sHYM","txt":"greeting_txt__X9zcr"};